module.exports = __webpack_public_path__ + "0bf4a7d619a31d986b2ac1e9f80cfbc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-dog-sincerely.png
// module id = 2047
// module chunks = 4